function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (typeof window !== "undefined" && window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

function getBackendUrl() {
    return getConfig('REACT_APP_BACKEND_URL');
}

function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}

function getNomeEmpresa() {
    return getConfig("REACT_APP_NOME_EMPRESA", "Orion");
}

function getVersionSystem() {
    return getConfig("REACT_APP_VERSION", "1.0.0");
}

export {
    getBackendUrl,
    getHoursCloseTicketsAuto,
    getFrontendPort,
    getPrimaryColor,
    getPrimaryDark,
    getNumberSupport,
    getNomeEmpresa,
    getVersionSystem
};

export default {
    getBackendUrl,
    getHoursCloseTicketsAuto,
    getFrontendPort,
    getPrimaryColor,
    getPrimaryDark,
    getNumberSupport,
    getNomeEmpresa,
    getVersionSystem
};